<template>
    <div :class="['page about',{ off: !pageOn }]">
        <!-- <Ham :on="on" @select="hamSelect" /> -->
        <VHeader @ham="on = true;" />
        <div class="page-content copper">
            <div v-if="AddMembers" style="position: relative;">
                <img class="page-image" src="/CopperWelcome-3.png" />
                <div class="div-btns" style="position: absolute;top:0px;left:0px">
                    <p @click="terms" style="background-color: rgba(200,0,0,0);width:320px;height:50px;top:350px;left: 30px;position: absolute;"></p>
                    <p @click="signUp" style="background-color: rgba(200,0,0,0);width:320px;height:80px;top:450px;left: 30px;position: absolute;"></p>
                </div>
            </div>
            <div v-if="!AddMembers">
                <h2 style="color:white;width: 80%;margin: 10%;line-height: 2;font-weight: 400;text-align: center;">We Are not accepting members, do you want to be added to the Wait List ?</h2>
                <input id="name" v-model="name" placeholder="Your Name"  />
                <input id="email" v-model="email" placeholder="Your Email"  />
                <input id="mobile" v-model="mobile" placeholder="Your Mobile"  />
                <p class="btn" @click="addToWait()">Add Me to the List</p>
            </div>
        </div>  
    </div>
</template>

<script>

import VHeader from '@/components/VHeader.vue'
import { pageOn } from '@/utils/pageOn.js'
import { mapActions, mapMutations, mapState } from 'vuex';
import WebSoc from '@/utils/WebSoc.js';
import Ham from '@/components/Ham.vue'
import Alert from '@/utils/Alert.js'

export default {
    name: 'copper',
    mixins: [ pageOn ],
    components: {
        VHeader,
        Ham
    },
    mounted () {
        var width = parseInt(getComputedStyle(this.$el.querySelector('.page-content')).width);
        this.$el.querySelector('.div-btns').style.transform = 'scale('+( width / 414 )+')';
        var id, _id;
        try {
            id = localStorage.id; _id = localStorage._id
        } catch(e) { };
        WebSoc.SEND({ t: 'checkCopper', data: { id, _id } },resp => {
            this.AddMembers = resp.AddMembers;
        })
        console.log('mounted Copper.vue')
    },
    data () {
        return {
            on: false,
            AddMembers: true,
            name: '',
            email: '',
            mobile: ''
        }
    },
    methods: {
        hamSelect ( page ) {
            this.on = false;
            this.pushPage(page);
            if ( page == 'terms' ) {
                this.$emit('showTerms');
            }
        },
        addToWait () {
            var email = this.email;
            var mobile = this.mobile;
            var name = this.name;
            if ( !email || email.indexOf('@') == - 1 ) return Alert.message('Invlid Email Address');
            if ( !mobile ) return Alert.message('Invalid Mobile Number');
            if ( !name ) return Alert.message('You need to fill in your name');
            
            WebSoc.SEND({ t: 'addWait', data: { name, email, mobile }},() => {

            });

            Alert.message('You have been added to the wait list we will be in touch soon',() => {
                this.name = '';
                this.email = '';
                this.mobile = '';
            });
            
        },
        signUp () {
            this.$emit('showDetail');
        },
        terms () {
            this.$emit('showTerms')
        },
        ...mapMutations([
            'popPage',
            'pushPage',
            'setValue'
        ])
    }
}

</script>

<style>

</style>